//Auth Urls
export const VERIFY_USER_URL =
  "mst-admin/authentication/verify-via-phone_Admin";
export const VERIFY_OTP = "matchseeker/authentication/verify-otp";
export const VERIFY_OTP_PHONE = "mst-admin/authentication/verify-otp-phone";

//dahsboard url 
export const GET_DASHBOARD_STATS_URL = "mst-admin/get-dashboard-stats"

//Match Seeker Url
export const GET_ALL_MATCHSEEKERS_URL = `mst-admin/get-all-match-seekers`;
export const GET_ALL_MATCHSEEKERS_URL_NOPAGINATION =
  "mst-admin/get-all-match-seekers/no-pagination";
export const GET_MST_MATCHSEEKER_URL = "mst-admin/master-data/get-all-master-data";
export const DELETE_MATCHSEEKER_URL = `mst-admin/deleteMatchSeeker/`;
export const CREATE_MATCHSEEKER_URL = "mst-admin/matchseeker/create-account";
export const EDIT_MATCHSEEKER_URL = "mst-admin/matchseeker/edit-account/";
export const GET_MATCHSEEKER_BY_ID_URL = "mst-admin/get-match-seeker-by-id/";
export const SEARCH_MATCHSEEKER_URL = "mst-admin/matchseeker/search-matchseekers?"
export const FILTER_MATCHSEEKER_URL = "mst-admin/matchseeker/filter-matchseekers?"
export const GET_MATCHSEEKER_SUB_DETAILS = "/mst-admin/matchseeker/get-subscription-details/"
export const LIST_MATCHSEEKERS_URL = "mst-admin/matchseeker/list-matchseekers"


// BG Profile connect request history (seeker-to-seeker, no matchmaker)
export const LIST_REQ_RECEIVED_FROM_BG_PROFILES = "mst-admin/list-requests-received/bgprofiles/"
export const LIST_REQ_SENT_TO_BG_PROFILES = "mst-admin/list-requests-sent/bgprofiles/"
export const LIST_PROFILES_RECEIVED_FROM_MS = "mst-admin/list-profiles-received/ms/"

// Bg Profile Url's
export const ADD_BG_PROFILE_URL = "mst-admin/bg-profile/create-profile"
export const GET_ALL_BG_PROFILE_URL =
  "mst-admin/bg-profile/get-bg-profiles-paginated";
export const DELETE_BGPROFILE_URL = "mst-admin/bg-profile/delete-profile/";
export const EDIT_BGPROFILE_URL = "mst-admin/bg-profile/edit-profile/";
export const GET_BGPROFILE_DETAILS_BY_ID_URL =
  "mst-admin/bg-profile/get-profile-by-id/";
export const CHECK_PHONE_NO_URL = "mst-admin/bg-profile/verify-via-phone_Admin/bgprofile"
export const VERIFY_OTP_BG_PROFILE_URL = "mst-admin/bg-profile/verify-otp/bgprofile"
export const SEARCH_BG_PROFILES_URL = "mst-admin/bg-profile/search-profiles?"
export const FILTER_BG_PROFILES_URL = "mst-admin/bg-profile/filter-profiles?"
export const LIST_BG_PROFILES_URL   = "mst-admin/bg-profile/list/?"


//SAM URLS 
export const GET_ALL_STAFF_PAGINATED_URL = "mst-admin/get-all-staff-pagination"
export const GET_ALL_STAFF_NO_PAGINATION_URL = "mst-admin/get-all-staff-noPagination"
export const CREATE_STAFF_URL = "mst-admin/create-staff"
export const EDIT_STAFF_URL = "mst-admin/update-staff/"
export const DELETE_STAFF_URL = "mst-admin/delete-staff/"
export const GET_STAFF_DETAILS_BY_ID = "mst-admin/get-staff-details/"
export const UPDATE_STAFF_PASSWORD_URL = "mst-admin/update-staff-pwd/"
export const SEARCH_STAFF_URL = "mst-admin/search-staff?" 
export const FILTER_STAFF_URL = "mst-admin/filter-staff?"   

//Authentication Url's 
export const STAFF_LOGIN_URL = "mst-admin/authenticate-staff" 
export const FORGOT_PWD_SEND_OTP_URL = "mst-admin/reset-staff-pwd"
export const VERIFY_RESET_PWD_OTP = "mst-admin/verify-otp-reset-pwd"

//Master Data Management Url's
export const CREATE_MASTER_DATA_URL = "/create"
export const DELETE_MASTER_DATA_URL = "/delete/"
export const EDIT_MASTER_DATA_URL   = "/update/"
export const GET_MASTER_DATA_URL    = "/get-all-mst"
export const GET_ALL_MODELS_MASTER_DATA_URL = "mst-admin/get-all-mst-models-data"
export const GET_MODAL_SCHEMA_URL   = `/get-modal-schema/`
export const GET_MODAL_DETAILS_BY_ID_URL = "/get-mst-details/"
export const REFRESH_MASTER_DATA_URL = "mst-admin/master-data/refresh"


// SUPPORT API'S
export const GET_ALL_SUPPORT_REQUESTS      = "mst-admin/get-all-support-requests?"
export const UPDATE_SUPPORT_REQUEST_STATUS = "mst-admin/update-support-request-status"

// REPORT API URLS 
export const GET_ALL_REPORTS_URL      = "mst-admin/reports/list?"
export const UPDATE_REPORT_STATUS_URL = "mst-admin/reports/update-status/"

// VERIFICATION REQUEST URL'S 
export const LIST_ALL_VERIFICATION_REQUESTS_URL = "mst-admin/verification-requests/list?"
export const UPDATE_VERIFICATION_REQUESTS_URL = "mst-admin/verification-request/update-request/"


//SUBSCRIPTION URLS
export const LIST_ALL_SUCBSCRIPTIONS_URL = "mst-admin/subscription/get-all-serviceplans?"
export const VIEW_SUBSCRIPTION_DETAILS_URL= "mst-admin/subscription/get-service-plan-details/"

// COMMAND DASHBOARD
export const GET_COMMAND_DASHBOARD_STATS_URL = "mst-admin/dashboard/stats"

// APP CONFIG
export const LIST_APP_CONFIG_URL = "mst-admin/config/list"
export const SEED_APP_CONFIG_URL = "mst-admin/config/seed"
export const BULK_UPDATE_APP_CONFIG_URL = "mst-admin/config/bulk-update"

// BROADCAST NOTIFICATIONS
export const SEND_BROADCAST_URL = "mst-admin/notifications/broadcast"
export const LIST_BROADCASTS_URL = "mst-admin/notifications/broadcasts"

// PROMO CODES
export const LIST_PROMO_CODES_URL = "mst-admin/promo-codes/list"
export const CREATE_PROMO_CODE_URL = "mst-admin/promo-codes/create"
export const UPDATE_PROMO_CODE_URL = "mst-admin/promo-codes/update/"
export const DELETE_PROMO_CODE_URL = "mst-admin/promo-codes/delete/"

// AUDIT LOG
export const GET_AUDIT_LOG_URL = "mst-admin/audit-log"

// PACK PURCHASES
export const SEARCH_PACK_PURCHASES_URL = "mst-admin/pack-purchases"
export const GET_PACK_PURCHASE_DETAIL_URL = "mst-admin/pack-purchases/"

// CONNECTS
export const LIST_CONNECTS_URL = "mst-admin/connects/list"

// SUBSCRIPTION ACTIONS
export const EXTEND_SUBSCRIPTION_URL = "mst-admin/subscription/extend/"
export const CANCEL_SUBSCRIPTION_URL = "mst-admin/subscription/cancel/"

// BG PROFILE BULK ACTIONS
export const BULK_APPROVE_BG_PROFILES_URL = "mst-admin/bg-profile/bulk-approve"

// NOTIFICATION SEGMENTS
export const SEGMENT_COUNT_URL = "mst-admin/notifications/segment-count"
export const BROADCASTS_HISTORY_URL = "mst-admin/notifications/broadcasts"

// MATCH CLOSURES
export const CLOSURE_STATS_URL = "mst-admin/closures/stats"
export const LIST_CLOSURES_URL = "mst-admin/closures"
export const GET_CLOSURE_DETAIL_URL = "mst-admin/closures/"

// FRAUD & REFUNDS
export const DUPLICATE_PHONES_URL = "mst-admin/fraud/duplicate-phones"
export const REFUNDABLE_PAYMENTS_URL = "mst-admin/fraud/refundable-payments"
export const PROCESS_REFUND_URL = "mst-admin/fraud/refund/"

// PACK USERS
export const LIST_USERS_BY_PACK_URL = "mst-admin/user-packs/by-type"

// SECOND MARRIAGE POOL
export const SECOND_MARRIAGE_POOL_URL = "mst-admin/second-marriage-pool"

// EVENTS
export const LIST_EVENTS_URL = "mst-admin/events"
export const CREATE_EVENT_URL = "mst-admin/events"
export const GET_EVENT_BY_ID_URL = "mst-admin/events/"
export const EDIT_EVENT_URL = "mst-admin/events/"
export const DELETE_EVENT_URL = "mst-admin/events/"
// The room: who registered, whether they are ready, what would break tonight.
export const EVENT_ROSTER_URL = "mst-admin/events/"        // + :id/roster
// The pre-event compute, previously a CLI script the panel told you to go run.
export const BUILD_EVENT_MATRIX_URL = "mst-admin/events/"  // + :id/build-matrix
// The money rail. Note the literal paths sit BEFORE /events/:id on the server,
// or "earnings" is cast as an event id and every call 404s.
export const EVENT_EARNINGS_URL        = "mst-admin/events/earnings"
export const EVENT_EARNING_DETAIL_URL  = "mst-admin/events/earnings/"  // + :matchmakerId
export const EVENT_EARNINGS_PAY_URL    = "mst-admin/events/earnings/"  // + :matchmakerId/mark-paid
// ── MatchMatrix Bureau (matchmaker rails) ────────────────────────────────────
// hostStatus/kycStatus had NO writer anywhere in the codebase before this
// module, so every bureau sat permanently unverified and could never host a
// Meet or be paid. PARTNER_STATUS_URL is that writer.
export const LIST_PARTNERS_URL     = "mst-admin/partners"
export const GET_PARTNER_BY_ID_URL = "mst-admin/partners/"        // + :id
export const PARTNER_STATUS_URL    = "mst-admin/partners/"        // + :id/status
export const PARTNER_INTAKES_URL   = "mst-admin/partners/intakes"
export const PARTNER_CONSENT_URL   = "mst-admin/partners/consent"
export const LIST_REFERRALS_URL     = "mst-admin/referrals"
export const GET_REFERRAL_BY_ID_URL = "mst-admin/referrals/"       // + :id
export const REFERRAL_STAGE_URL     = "mst-admin/referrals/"       // + :id/stage
export const REFERRAL_NOTE_URL      = "mst-admin/referrals/"       // + :id/notes
export const REFERRAL_REWARD_URL    = "mst-admin/referrals/"       // + :id/reward
